'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = exports.formatDuration = exports.toUtc = exports.getItemTime = exports.getItemDate = exports.formatTimeUTC = exports.formatTime = exports.formatDate = void 0;
var regions = Array.from(navigator.languages || []);
var dateFormat = new Intl.DateTimeFormat(regions);
var timeFormat = new Intl.DateTimeFormat(regions, {
    hour: 'numeric',
    minute: 'numeric',
});
var timeFormatUTC = new Intl.DateTimeFormat(regions, {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'UTC',
});
/**
 * Formats date using the local Intl.DateTimeFormat instance
 * @param value date as string, number or istance of Date
 */
function formatDate(value) {
    var date = value instanceof Date ? value : new Date(value);
    return dateFormat.format(date);
}
exports.formatDate = formatDate;
/**
 * Formats time using the local Intl.DateTimeFormat instance
 * @param value date as string, number or instance of Date
 */
function formatTime(value) {
    var date = value instanceof Date ? value : new Date(value);
    return timeFormat.format(date);
}
exports.formatTime = formatTime;
/**
 * Formats time with UTC timezone using the local Intl.DateTimeFormat instance
 * @param value date as string, number or instance of Date
 */
function formatTimeUTC(value) {
    var date = value instanceof Date ? value : new Date(value);
    return timeFormatUTC.format(date);
}
exports.formatTimeUTC = formatTimeUTC;
/**
 * Formats a date value as a local or UTC date string.
 *
 * @param value - The date to format (Date, string, or number).
 * @param isLocalTime - Whether to format as local time (default: false).
 * @returns The formatted date string.
 */
function getItemDate(value, isLocalTime) {
    if (isLocalTime === void 0) { isLocalTime = false; }
    var date = value instanceof Date ? value : new Date(value);
    if (isLocalTime) {
        return formatDate(date);
    }
    else {
        return formatDate(toUtc(date));
    }
}
exports.getItemDate = getItemDate;
/**
 * Formats a date value as a local or UTC time string.
 *
 * @param value - The date to format (Date, string, or number).
 * @param isLocalTime - Whether to format as local time (default: false).
 * @returns The formatted time string.
 */
function getItemTime(value, isLocalTime) {
    if (isLocalTime === void 0) { isLocalTime = false; }
    var date = value instanceof Date ? value : new Date(value);
    if (isLocalTime) {
        return formatTime(date);
    }
    else {
        return formatTimeUTC(toUtc(date));
    }
}
exports.getItemTime = getItemTime;
/**
 * Add a trailing Z to any date.
 * Why? ISO 8601 date format has a trailing Z, but it is missing in the server response making the browser think the date is in local time, not UTC. since we know for a fact the server returns UTC dates, we 'artificially' add it here so the formatter will work correctly.
 * @param value date as a Date Object
 */
function toUtc(value) {
    if (value instanceof Date) {
        return new Date(value.toISOString());
    }
    else if (typeof value === 'number') {
        return new Date(value);
    }
    var utcDate = value.toString();
    if (utcDate.indexOf('Z') === -1) {
        utcDate = value + 'Z';
    }
    return new Date(utcDate);
}
exports.toUtc = toUtc;
/**
 * Formats a duration to be displayed as hours and
 * minutes.
 * @param duration duration in minutes
 */
function formatDuration(duration) {
    var durationNum = parseInt(duration, 10);
    var hours = Math.floor(durationNum / 60);
    var mins = durationNum % 60;
    if (hours > 0) {
        return hours + "h " + mins + "m";
    }
    else {
        return mins + " mins";
    }
}
exports.formatDuration = formatDuration;
/**
 * Formats an amount of money to be displayed with its currency
 * @param amount amount of money
 */
function formatCurrency(amount, currency, decimals, currencyDisplay) {
    if (amount === null) {
        return '-';
    }
    var currencyFormat = new Intl.NumberFormat(regions, {
        style: 'currency',
        currency: currency,
        currencyDisplay: currencyDisplay,
        // if maximum is less than 2 we need to specify range
        minimumFractionDigits: decimals < 2 ? 0 : undefined,
        maximumFractionDigits: decimals,
    });
    return currencyFormat.format(amount);
}
exports.formatCurrency = formatCurrency;
